import { relativeTimeLabel } from '@/features/schedules/relativeTimeLabel'

export const UPDATE_STATUS_LABEL = { done: 'Completed', attention: 'Needs attention', failed: 'Failed' }

const durationLabel = (sec) => (sec >= 60 ? `${Math.floor(sec / 60)}m ${sec % 60}s` : `${sec}s`)

/** "Needs attention · ran 2 hours ago · took 52s" */
export function updateMetaLabel(update) {
  return [
    UPDATE_STATUS_LABEL[update.status],
    `ran ${relativeTimeLabel(update.at)}`,
    `took ${durationLabel(update.durationSec)}`,
  ].join(' · ')
}

/** What the ask bar is filled with when the user follows up on a run result. */
export function followUpText(update) {
  const day = new Date(update.at).toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' })
  return `About my “${update.sourceTitle}” update from ${day} (${update.headline}): `
}

/** "now", "12m", "3h", "2d" — compact enough for the rail and activity rows. */
export function shortAgo(at, now = Date.now()) {
  const minutes = Math.max(0, Math.floor((now - at) / 60_000))
  if (minutes < 1) return 'now'
  if (minutes < 60) return `${minutes}m`
  const hours = Math.floor(minutes / 60)
  return hours < 24 ? `${hours}h` : `${Math.floor(hours / 24)}d`
}
